export default __webpack_public_path__ + "3c9e6c49238228e43b016c25337e4954.png";